import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import usersService from "../../../Axios/services/users.service";
import avatar from "./../../../assets/images/avatar.png";
import search_normal from "./../../../assets/images/search-normal.svg";
import { setCurrentPage, setSidebarRouteData } from "../../../store/actions/mainActions";
import "./EventParticipantsPage.scss";
import eventsService from "../../../Axios/services/events.service";
import React from "react";
import { EventParticipantsProps } from "./EventParticipantsProps";
import { useDebounce } from "../../../helpers/helpers";

export const EventParticipantsPage = () => {
  const { currentEvent, currentParticipantsEvent } = useSelector((state: any) => state.main);
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();

  const [participants, setParticipants] = useState<EventParticipantsProps[]>([]);
  const [searchLearner, setSearchLearner] = useState<string>("");
  const [filteredParticipants, setFilteredParticipants] = useState<EventParticipantsProps[]>([]);
  const [event, setEvent] = useState<any>(undefined);
  const { me } = useSelector((state: any) => state.auth);
  const [entityLanguage, setEntityLanguage] = useState<string>("common");
  const [t] = useTranslation(entityLanguage);

  useEffect(() => {
    getParticipantsData();
    getEventData();

    return () => {
      dispatch(setSidebarRouteData({}));
      dispatch(setCurrentPage(""));
    };
  }, [dispatch, me, id]);

  const getParticipantsData = async () => {
    let participantsData = currentParticipantsEvent || (await usersService.getParticipantsByEventId(id));

    setParticipants(participantsData);
    setFilteredParticipants(participantsData);

    dispatch(setCurrentPage("EventParticipantsPage"));
    dispatch(setSidebarRouteData({ id }));
  };

  const getEventData = async () => {
    let eventData = [];
    eventData = currentEvent ||  await eventsService.getEvent(id);
    eventData = currentEvent;
    
    setEntityLanguage(event?.language);
    setEvent(eventData);
  };

  const handleSearch = () => {
    if (searchLearner.trim()) {
      const results = participants.filter((part) => part.fullName.toLowerCase().includes(searchLearner.toLowerCase()));
      setFilteredParticipants(results);
    } else {
      setFilteredParticipants(participants);
    }
  };

  const debouncedSearch = useDebounce(handleSearch, 300);

  const handleInputChange = (event) => {
    const eventValue = event.target.value;
    setSearchLearner(eventValue);
    debouncedSearch(eventValue);
  };

  return participants && event ? (
    <div
      className={`event-page container-fluid ${
        event.language === "English" ? null : "alignRight"
      }`}
    >
      <div className="goBack" onClick={() => navigate('/my-campus/event/timeline/' + id)}>
        {t("Back to seminar")}
      </div>
      <div className="cimage mb-md-4 mb-2 ">{event.thumbnail ? <img src={event.thumbnail} /> : null}</div>
      <div className="mb-md-4 mb-2 align-items-center justify-content-between">
        <div className={`ctitle ${event.language === "English" ? null : "alignRightBold"}`}>{event.eventTitle}</div>
      </div>
      <div className="search-container">
        <input type="text" placeholder="Search Learners" className="search-input" value={searchLearner} onChange={handleInputChange} />
        <button onClick={handleSearch} className="search-icon">
          <img src={search_normal} alt="" />
        </button>
      </div>

      <div className="participants">
        {filteredParticipants.length > 0 ? (
          filteredParticipants.map((part, index) => (
            <div key={index} className="participant-row">
              <div className="participant-photo-container">
                {part.image ? <img className="participant-photo" src={part.image} alt={part.fullName} /> : <img className="participant-photo" src={avatar} alt="default avatar" />}
              </div>
              <div className="user-details">
                <div className="user-name">{part.fullName} </div>
                {part.title && <div className="user-info">{part.title}</div>}
              </div>
              {/* {index < part.length - 1 && <hr className="line" />} */}
            </div>
          ))
        ) : (
          <p>No participants found</p>
        )}
      </div>
    </div>
  ) : null;
};
